import { FooterCard } from 'ui/components/2-molecules/Card/FooterCard';

export const FooterCardFeature: React.FC<Umbraco.FooterCard> = (footerCard) => {
	return <FooterCard {...footerCard?.content?.properties} />;
};
